import React, { useEffect, useRef, useState } from "react";
import { getEnvUrl, getToken } from "../../../utils/Api"; 
import Loader from "../../common/loader";
import $ from "jquery";
import "datatables.net";
import  {getSubjects} from "../../../Services/Subjects/SubjectServices"
import  {getCategories,getgames,deleteReview} from "../../../Services/gameServices"
import { toast } from 'react-toastify';
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const GameReviews = ({ data }) => {
   const tableRef = useRef(null);
   const [isLoading, setIsLoading]        = useState(true);
   const [subjectData, setSubjectData]    = useState([]);
   const [categoryData, setCategoryData]  = useState([]);
   const [gameData, setGameData]       = useState([]);
   const [subjectId, setSubjectId]     = useState('');
   const [categoryId, setCategoryId]   = useState('');
   const [gameId, setGameId]           = useState('');
   const [render, setRender]           = useState(true); 
   const navigate = useNavigate();
   useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
       processing: true,
       serverSide: true,
       serverMethod: "get",
       ajax: {
          url: `${getEnvUrl()}/admin/game/getGameReviewReport?subject=${subjectId}&category=${categoryId}&gameid=${gameId}`,
          headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${getToken()}`,
          },
       },
       columns: [
          { data: "reviewid" },
          { data: "review" },
          { data: "email" },
          { data: "displayname" },
          { data: "mobilenumber" },
          { data: "gamename" },
          { data: "action" },
       ],
       columnDefs: [
          {
             targets: [6], /* column index */
             orderable: false, /* true or false */
          },
       ],
       createdRow: (row, data, dataIndex) => {  
         if(!checkPermissions('game_review_delete')){
            $(row).find('.a-delete').remove();
          }
         $(row).find('.a-delete').on('click', () => {  
          if(window.confirm('Are you sure to delete?')){ 
            deleteReview(data.reviewid).then((data)=>{ 
              if(data.status){
                   toast.success(data.message)
                   setRender(!render)
              } else{
                toast.error(data.errorMessage) 
              }
            })  
          } 

         } );
       },
       drawCallback: function (settings) {
          setIsLoading(false);
       },
       aaSorting: [[0, "desc"]],
    });

    return () => {
       // Destroy DataTable when component unmounts to avoid memory leaks
       table.destroy();
    };
 }, [data,subjectId,categoryId,gameId,render]);

   useEffect(() => {
      if(!checkPermissions('game_review_page') || !checkPermissions('games_navigation')){ 
            navigate('/')
          }
      getSubjects().then((data)=>{ 
         if(data.status){
            setSubjectData(data.data)
         } 
      })
   }, []); 
   const callCategories = (e) => {
      const value = e.target.value;
      setSubjectId(value);
      setGameData([])
      setCategoryId('');
      setGameId('');
      if (value !== "") {
          getCategories(value)
              .then((data) => { 
                  setCategoryData(data?.status ? data.data : []);
              })
              .catch((error) => {
                  console.error("Error fetching categories:", error);
                  setCategoryData([]);
              });
      } else {
          setCategoryData([]);
      }
  };

  const callGames = (e) => {
   const value = e.target.value;
   setCategoryId(value);
   setGameId('');
   if (value !== "") {
       getgames(value)
           .then((data) => {
            console.log(data)
            setGameData(data?.status ? data.data : []);
           })
           .catch((error) => {
               console.error("Error fetching categories:", error);
               setGameData([]);
           });
   } else {
      setGameData([]);
   }
};

const resetFilter = () => { 
   setSubjectId('');
   setCategoryId('');
   setGameId('');
};
 
 

   return (
      <div>
         <main id="main" className="main">
            <div className="pagetitle">
               <h1>Games Review</h1>
            </div>
            <section className="section">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="card p-10">
                        <div className="row g-1 align-items-end mb-10">
                        <div className="col-sm-2">
                              <select
                                 className="form-control"
                                 id="subjectfilter"
                                 onChange={callCategories}  >
                                 <option value="">--Select Subject--</option>
                                 {
                                    subjectData.map((data)=>{
                                       return (<>
                                         <option value={data.id}>{data.name}</option>
                                       </>)
                                    })
                                 }
                              </select>
                           </div>
                           <div className="col-sm-2">
                              <select className="form-control"
                              value={categoryId} onChange={callGames}>
                                 <option value="">--Select Category--</option>
                                 {categoryData.map((data)=>{
                                    return (<>
                                     <option value={data.id}>{data.name}</option>
                                    </>)
                                 })}
                              </select>
                           </div>
                           <div className="col-sm-2">
                              <select className="form-control" 
                              value={gameId}
                              onChange={(e)=>{setGameId(e.target.value)}}>
                                 <option value="">--Select game--</option>
                                 {gameData.map((data)=>{
                                    return(<>
                                      <option value={data.id}>{data.name}</option>
                                    </>)
                                 })}
                              </select>
                           </div>
                           <div className="col-sm-2">
                              <button className="btn btn-primary" onClick={resetFilter}  >Reset</button>
                           </div>
                        </div>
                        {isLoading ? <Loader /> : ""}
                        <div className={isLoading ? "card-body hide" : "card-body"}>
                           <table
                              className="table table-striped table-hover table-bordered no-footer dataTable"
                              width="100%"
                              ref={tableRef}
                           >
                              <thead>
                                 <tr>
                                    <th>Review Id</th>
                                    <th>Review</th>
                                    <th>Email</th>
                                    <th>User name</th>
                                    <th>Mobile number</th>
                                    <th>Game Name</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                           </table>
                        </div>
                     </div>
                  </div>
               </div>
            </section>
         </main>
      </div>
   );
};

export default GameReviews;
